// Maps Firebase Auth error codes to messages a person can act on.
// Raw codes ("Firebase: Error (auth/invalid-credential).") were being shown
// verbatim, which an NVDA end-user test (27 Jul 2026) flagged as unhelpful.
const MESSAGES = {
    'auth/invalid-credential': 'Incorrect email or password. Please try again.',
    'auth/invalid-login-credentials': 'Incorrect email or password. Please try again.',
    'auth/wrong-password': 'Incorrect email or password. Please try again.',
    'auth/user-not-found': 'No account found with that email address.',
    'auth/invalid-email': 'That email address does not look valid.',
    'auth/user-disabled': 'This account has been disabled. Please contact support.',
    'auth/too-many-requests': 'Too many attempts. Please wait a few minutes and try again.',
    'auth/network-request-failed': 'Could not reach the server. Please check your connection and try again.',
    'auth/email-already-in-use': 'An account already exists with that email address. Try signing in instead.',
    'auth/weak-password': 'That password is too weak. Please choose a stronger one.',
    'auth/popup-closed-by-user': 'The sign-in window was closed before finishing.',
};

export const friendlyAuthError = (err, fallback) => {
    if (err && err.code && MESSAGES[err.code]) return MESSAGES[err.code];
    return fallback;
};

export default friendlyAuthError;
